module.exports = __webpack_public_path__ + "static/2-2589f6a396ac42a0f5f42478f5e9efdc.jpg";